import { createSlice } from "@reduxjs/toolkit";

const getDefaultDates = () => {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - 29);
  return {
    startDate: start.toISOString().split("T")[0],
    endDate: today.toISOString().split("T")[0],
  };
};

const filterSlice = createSlice({
  name: "filters",
  initialState: {
    selectedCompanyId: null,  
    yards: [],
    shippingLines: [],
    useShippingLineFilter: false,
    filterMode: "date",
    currentPage: 1,
    itemsPerPage: 20,
    sortConfig: { key: null, direction: "asc" },
    activeTab: "all",
    searchQuery: "",
    days: "90",
    scrollPosition: 0,
    ...getDefaultDates(),
  },
  reducers: {
    setFilters: (state, action) => ({ ...state, ...action.payload }),
    resetFilters: () => ({
      selectedCompanyId: null,  
      yards: [],
      shippingLines: [],
      useShippingLineFilter: false,
      filterMode: "date",
      currentPage: 1,
      itemsPerPage: 20,
      sortConfig: { key: null, direction: "asc" },
      activeTab: "all",
      searchQuery: "",
      days: "90",
      scrollPosition: 0,
      ...getDefaultDates(),
    }),
  },
});

export const { setFilters, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;